import NewFolderModal from './NewFolderModal';

export default NewFolderModal;
